module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-textarea', _vm._b({
    attrs: {
      "label": _vm.label,
      "append-icon": "fullscreen"
    },
    on: {
      "click:append": function($event) {
        _vm.showdialog = true
      }
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  }, 'v-textarea', _vm.initialAttrs, false)), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.fullscreen
    },
    model: {
      value: (_vm.showdialog),
      callback: function($$v) {
        _vm.showdialog = $$v
      },
      expression: "showdialog"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showdialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-textarea', _vm._b({
    attrs: {
      "label": _vm.label
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  }, 'v-textarea', _vm.attrs, false))], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showdialog = false
      }
    }
  }, [_vm._v("\n          Done\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9de0c34","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/TextEditor.vue
// module id = 1532
// module chunks = 9